import { useEffect, useState } from "react";
import "./GlIntegration.scss";
import { useSelector } from "react-redux";
import newRequest from "../../../utils/newRequest";
import { ScaleLoader } from "react-spinners";
import { IoClose, IoAdd, IoCloseSharp, IoCheckmarkDone } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";
import { motion } from "framer-motion";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Chip,
    TablePagination,
} from "@mui/material";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { FaSave } from "react-icons/fa";
import { showToast } from "../../../toastService";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { fetchMainLedgers, fetchSubLedgers } from "../../../utils/genericFunctions";


const GlIntegration = () => {
    const { t } = useTranslation();
    const { currentTheme } = useSelector((state) => state.theme);
    const { currentUser } = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [searchTermIntegration, setSearchTermIntegration] = useState("");
    const [searchTermTypes, setSearchTermTypes] = useState("");
    const [currentAction, setCurrentAction] = useState(null);
    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        new_doc_status: "",
    });
    const [bizUnits, setBizUnits] = useState([]);
    const [entityCategories, setEntityCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [allSubClasses, setAllSubClasses] = useState([]);
    const [subClasses, setSubClasses] = useState([]);
    const [allCovers, setAllCovers] = useState([]);
    const [covers, setCovers] = useState([]);
    const [newCode, setNewCode] = useState("");
    const [newText, setNewText] = useState("");
    const [isLedgerDialogOpen, setIsLedgerDialogOpen] = useState(false);
    const [integrationRowsPerPage, setIntegrationRowsPerPage] = useState(4);
    const [integrationPage, setIntegrationPage] = useState(0);
    const [selectedIntegration, setSelectedIntegration] = useState(null);
    const [integrations, setIntegrations] = useState([]);
    const [selectedIntegrationType, setSelectedIntegrationType] = useState(null);
    const [integrationTypes, setIntegrationTypes] = useState([]);
    const [selectedBizUnitFm, setSelectedBizUnitFm] = useState(null);
    const [selectedBizUnitTo, setSelectedBizUnitTo] = useState(null);
    const [selectedProductFm, setSelectedProductFm] = useState(null);
    const [selectedProductTo, setSelectedProductTo] = useState(null);
    const [selectedClassFm, setSelectedClassFm] = useState(null);
    const [selectedClassTo, setSelectedClassTo] = useState(null);
    const [selectedSubClassFm, setSelectedSubClassFm] = useState(null);
    const [selectedSubClassTo, setSelectedSubClassTo] = useState(null);
    const [selectedCoverFm, setSelectedCoverFm] = useState(null);
    const [selectedCoverTo, setSelectedCoverTo] = useState(null);
    const [selectedAentFm, setSelectedAentFm] = useState(null);
    const [selectedAentTo, setSelectedAentTo] = useState(null);
    const [selectedChargeFm, setSelectedChargeFm] = useState(null);
    const [selectedChargeTo, setSelectedChargeTo] = useState(null);
    const [charges, setCharges] = useState([]);

    const [intLedgers, setIntLedgers] = useState([]);
    const [ledgerTypes, setLedgerTypes] = useState([]);
    const [selectedLedgerType, setSelectedLedgerType] = useState(null);
    const [selectedMgl, setSelectedMgl] = useState(null);
    const [selectedSgl, setSelectedSgl] = useState(null);

    const fetchIntegrationTypes = async () => {
        try {
            const applicableTypes = [
                { _id: "uw premium booked", code: "uw premium booked", name: "UW Premium Booked" }, // to hold booked premium
                { _id: "uw charges", code: "uw charges", name: "UW Charges" }, // to hold accumulated charges
                { _id: "uw comm payable", code: "uw comm payable", name: "UW Comm Payable" }, // to hold accumulated commission payable
                { _id: "ri premium ceded", code: "ri premium ceded", name: "RI Premium Ceded" }, // to hold RI Ceded Premium
                { _id: "ri charges", code: "ri charges", name: "RI Charges" } // to hold RI earned commission
            ];
            setIntegrationTypes(applicableTypes);
            setSelectedIntegrationType(applicableTypes[0]);
            await fetchIntegration(applicableTypes[0].code);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const fetchLedgerTypes = async () => {
        try {
            let options = ["primary", "secondary"].map((typ) => ({
                value: typ,
                label: typ,
            }));
            setLedgerTypes(options);
        } catch (error) {
            console.error("Error fetching receipt modes :", error);
        }
    };

    const fetchIntegration = async (intType) => {
        try {
            setIsProcessing(true);
            setIntegrations([]);
            const res = await newRequest.post("/integration/getIntegrations", { int_type: intType });
            setIntegrations(res.data);
            setIntLedgers(res.data?.int_ledgers);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsProcessing(false);
        }
    };
    const handleIntegrationChangePage = (event, newPage) => {
        setIntegrationPage(newPage);
    };
    const handleIntegrationChangeRowsPerPage = (event) => {
        setIntegrationRowsPerPage(parseInt(event.target.value, 4));
        setIntegrationPage(0);
    };
    const slicedIntegrationData = integrations?.slice(
        integrationPage * integrationRowsPerPage,
        integrationPage * integrationRowsPerPage + integrationRowsPerPage
    );


    const handleIntegrationsChange = (value, rowId, field) => {
        setIntegrations((prevIntegs) =>
            prevIntegs.map((item) =>
                item._id === rowId
                    ? { ...item, [field]: value, changed_xx: "Y" }
                    : item
            )
        );
    };


    const fetchCharges = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Charges" });
            let options = res.data.map((mode) => ({
                value: mode?.sys_code,
                label: mode?.sys_code,
            }));

            // Add "!" at the beginning and "~~~~~" at the end
            options = [{ value: "!", label: "!" }, ...options, { value: "~~~~~", label: "~~~~~" }];
            // console.log(`options: ${JSON.stringify(options, null, 2)}`);
            setCharges(options);
        } catch (error) {
            console.error("Error fetching charges :", error);
        }
    };

    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "deleteIntegration") {
                setIsProcessing(true);
                const res = await newRequest.delete(`/integration/del/${selectedIntegration?._id}`);
                setIsProcessing(false);
                if (res.data?.msg === "deleted") {
                    setIntegrations((prev) =>
                        prev.filter(param => param._id !== selectedIntegration?._id)
                    );
                    showToast("Deleted!", "success");
                } else {
                    showToast("Error removing integration!", "error");
                }
            }
        } catch (err) {
            console.log(err);
        }
        // Close the dialog
        setIsConfirmDialogOpen(false);
    };




    const fetchBizUnits = async () => {
        try {
            const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });

            let options = res.data.map((bu) => ({
                value: bu?.unit_code,
                label: bu?.unit_name,
            }));

            // Add "!" at the beginning and "~~~~~" at the end
            options = [{ value: "!", label: "!" }, ...options, { value: "~~~~~", label: "~~~~~" }];

            setBizUnits(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };


    const fetchEntityCategories = async () => {
        try {
            const res = await newRequest.get("/allEntityCatg/findAll");

            let options = res.data.map((bu) => ({
                value: bu?.aent_code,
                label: bu?.aent_name,
            }));

            // Add "!" at the beginning and "~~~~~" at the end
            options = [{ value: "!", label: "!" }, ...options, { value: "~~~~~", label: "~~~~~" }];

            setEntityCategories(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const fetchProducts = async () => {
        try {
            const res = await newRequest.post("/uwProduct/findAll", { lean: "Y" });

            let options = res.data.map((pr) => ({
                value: pr?.pr_code,
                label: pr?.pr_name,
            }));

            // Add "!" at the beginning and "~~~~~" at the end
            options = [{ value: "!", label: "!" }, ...options, { value: "~~~~~", label: "~~~~~" }];

            setProducts(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };


    const fetchAllSubClasses = async () => {
        try {
            const res = await newRequest.post("/uwProductSc/getProductSubClassRange", {
                product_code_fm: "!",
                product_code_to: "~~~~~"
            });

            let options = res.data.map((pr) => ({
                pr_code: pr?.ps_pr_code, // Product Code
                mc_code: pr?.ps_mc_code,    // Main Class Code
                sc_code: pr?.ps_sc_code,    // Subclass Code
                value: `${pr?.ps_pr_code}-${pr?.ps_mc_code}-${pr?.ps_sc_code}`, // Unique key
                label: pr?.sc_name_xx,
            }));

            // Add "!" at the beginning and "~~~~~" at the end
            options = [
                { pr_code: "!", mc_code: "!", sc_code: "!", value: "!", label: "!" },
                ...options,
                { pr_code: "~~~~~", mc_code: "~~~~~", sc_code: "~~~~~", value: "~~~~~", label: "~~~~~" }
            ];

            setAllSubClasses(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };



    const handleSubClassFocus = (productFm, productTo) => {
        console.log(`handleSubClassFocus ... productFm ${productFm} - productTo ${productTo}`);
        if (productFm && productTo) {
            const filteredSubClasses = allSubClasses.filter(
                (sc) => sc.pr_code >= productFm && sc.pr_code <= productTo
            );
            console.log(`filteredSubClasses: ${JSON.stringify(filteredSubClasses, null, 2)}`);
            let options = filteredSubClasses.map((sc) => ({
                pr_code: sc?.pr_code,
                mc_code: sc?.mc_code,
                sc_code: sc?.sc_code,
                value: sc?.value,
                label: sc?.label,
            }));
            // Add "!" at the beginning and "~~~~~" at the end
            options = [{ pr_code: "!", mc_code: "!", sc_code: "!", value: "!", label: "!" }
                , ...options,
            { pr_code: "~~~~~", mc_code: "~~~~~", sc_code: "~~~~~", value: "~~~~~", label: "~~~~~" }];
            // console.log(`setSubClasses: ${JSON.stringify(options, null, 2)}`);
            setSubClasses(options);
        }
    };


    const fetchAllCovers = async () => {
        try {

            const res = await newRequest.post("/uwSubClassCover/findAll", {
                cc_mc_code: "",
                cc_sc_code: ""
            });

            let options = res.data.map((cc) => ({
                mc_code: cc?.cc_mc_code,
                sc_code: cc?.cc_sc_code,
                cc_code: cc?.cc_code,
                value: `${cc?.cc_mc_code}-${cc?.cc_sc_code}-${cc?.cc_code}`,
                label: cc?.cc_name,
            }));

            // Add "!" at the beginning and "~~~~~" at the end
            options = [
                { mc_code: "!", sc_code: "!", cc_code: "!", value: "!", label: "!" },
                ...options,
                { mc_code: "~~~~~", sc_code: "~~~~~", cc_code: "~~~~~", value: "~~~~~", label: "~~~~~" }
            ];
            // console.log(`setAllSubClasses: ${JSON.stringify(options, null, 2)}`);
            setAllCovers(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const handleCoverFocus = (subClassFm, subClassTo, rowId) => {
        console.log(`handleCoverFocus ... subClassFm ${subClassFm} - subClassTo ${subClassTo}`);

        if (subClassFm && subClassTo) {
            // Filter preloaded subclasses based on the selected product range
            // console.log(`allCovers  ${JSON.stringify(allCovers, null, 2)}`);
            const filteredCovers = allCovers.filter(
                (sc) => sc.cc_code >= subClassFm && sc.cc_code <= subClassTo
            );

            console.log(`filteredCovers  ${JSON.stringify(filteredCovers, null, 2)}`);
            let options = filteredCovers.map((sc) => ({
                mc_code: sc?.mc_code,
                sc_code: sc?.sc_code,
                cc_code: sc?.cc_code,
                value: sc?.value,
                label: sc?.label,
            }));

            // Add "!" at the beginning and "~~~~~" at the end
            options = [{ mc_code: "!", sc_code: "!", cc_code: "!", value: "!", label: "!" }
                , ...options,
            { mc_code: "~~~~~", sc_code: "~~~~~", cc_code: "~~~~~", value: "~~~~~", label: "~~~~~" }];

            console.log(`setCovers: ${JSON.stringify(options, null, 2)}`);

            setCovers(options);
        }
    };

    const handleAddIntegration = async (e) => {
        try {
            if (!selectedBizUnitFm) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select business unit range!`);
                setIsNotifyDialogOpen(true);
                return;
            }
            if (!selectedBizUnitTo) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select business unit range!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            if (!selectedProductFm) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select product range!`);
                setIsNotifyDialogOpen(true);
                return;
            }
            if (!selectedProductTo) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select product range!`);
                setIsNotifyDialogOpen(true);
                return;
            }


            // if (!selectedSubClassFm) {
            //     setNotifyDialogTitle("Note!");
            //     setNotifyDialogText(`Please select sub class range!`);
            //     setIsNotifyDialogOpen(true);
            //     return;
            // }
            // if (!selectedSubClassTo) {
            //     setNotifyDialogTitle("Note!");
            //     setNotifyDialogText(`Please select sub class range!`);
            //     setIsNotifyDialogOpen(true);
            //     return;
            // }


            // if (!selectedCoverFm) {
            //     setNotifyDialogTitle("Note!");
            //     setNotifyDialogText(`Please select cover range!`);
            //     setIsNotifyDialogOpen(true);
            //     return;
            // }
            // if (!selectedCoverTo) {
            //     setNotifyDialogTitle("Note!");
            //     setNotifyDialogText(`Please select cover range!`);
            //     setIsNotifyDialogOpen(true);
            //     return;
            // }


            // if (!selectedAentFm) {
            //     setNotifyDialogTitle("Note!");
            //     setNotifyDialogText(`Please select entity category range!`);
            //     setIsNotifyDialogOpen(true);
            //     return;
            // }
            // if (!selectedAentTo) {
            //     setNotifyDialogTitle("Note!");
            //     setNotifyDialogText(`Please select entity category range!`);
            //     setIsNotifyDialogOpen(true);
            //     return;
            // }

            setIsProcessing(true);
            let res = null;

            if (objectToAction?.new_doc_status === "newIntegration") {
                res = await newRequest.post("/integration/add", {
                    int_type: selectedIntegrationType.code,
                    int_remarks: selectedIntegrationType.name,
                    int_biz_unit_fm: selectedBizUnitFm?.value,
                    int_biz_unit_to: selectedBizUnitTo?.value,
                    int_product_fm: selectedProductFm?.value,
                    int_product_to: selectedProductTo?.value,
                    int_class_fm: selectedClassFm?.value,
                    int_class_to: selectedClassTo?.value,
                    int_sub_class_fm: selectedSubClassFm?.sc_code,
                    int_sub_class_to: selectedSubClassTo?.sc_code,
                    int_cover_fm: selectedCoverFm?.cc_code,
                    int_cover_to: selectedCoverTo?.cc_code,
                    int_aent_fm: selectedAentFm?.value,
                    int_aent_to: selectedAentTo?.value,
                    int_charge_fm: selectedChargeFm?.value || "!",
                    int_charge_to: selectedChargeTo?.value || "~~~~~",
                    int_ledgers: intLedgers
                });
                console.log(`LH 44 ${JSON.stringify(res.data, null, 2)}`);
                if (res.data?.msg === "added") {
                    setIntegrations((prev) => [...prev, res.data?.doc]);
                    setIsLedgerDialogOpen(false);
                    setIsProcessing(false);
                    showToast("Added!", "success");
                } else {
                    showToast(res.data?.msg, "error");
                }
            } else if (objectToAction?.new_doc_status === "editIntegration") {
                res = await newRequest.put(`/integration/upd/${selectedIntegration?._id}`, {
                    int_type: selectedIntegrationType.code,
                    int_remarks: selectedIntegrationType.name,
                    int_biz_unit_fm: selectedBizUnitFm?.value,
                    int_biz_unit_to: selectedBizUnitTo?.value,
                    int_product_fm: selectedProductFm?.value,
                    int_product_to: selectedProductTo?.value,
                    int_class_fm: selectedClassFm?.value,
                    int_class_to: selectedClassTo?.value,
                    int_sub_class_fm: selectedSubClassFm?.sc_code,
                    int_sub_class_to: selectedSubClassTo?.sc_code,
                    int_cover_fm: selectedCoverFm?.cc_code,
                    int_cover_to: selectedCoverTo?.cc_code,
                    int_aent_fm: selectedAentFm?.value,
                    int_aent_to: selectedAentTo?.value,
                    int_charge_fm: selectedChargeFm?.value || "!",
                    int_charge_to: selectedChargeTo?.value || "~~~~~",
                    int_ledgers: intLedgers
                });
                console.log(`LH 47 ${JSON.stringify(res.data, null, 2)}`);
                if (res.data?.msg === "updated") {
                    const updatedRow = res.data?.doc;
                    setIntegrations((prevParams) => {
                        return prevParams.map((report) =>
                            report._id === updatedRow._id ? updatedRow : report
                        );
                    });
                    setIsLedgerDialogOpen(false);
                    setIsProcessing(false);
                    showToast("Updated!", "success");
                } else {
                    showToast(res.data?.msg, "error");
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsProcessing(false);
        }
    };

    const saveRecord = async (e) => {
        try {
            const changedIntegration = integrations?.filter((obj) => obj.changed_xx === "Y");
            console.log(`changedIntegration  ${JSON.stringify(changedIntegration, null, 2)}`);
            // return;

            setIsProcessing(true);


            for (let i = 0; i < changedIntegration?.length; i++) {
                const res = await newRequest.put(
                    `/integration/upd/${changedIntegration[i]._id}`,
                    {
                        int_remarks: changedIntegration[i].int_remarks,
                        int_biz_unit_fm: changedIntegration[i].int_biz_unit_fm,
                        int_biz_unit_to: changedIntegration[i].int_biz_unit_to,
                        int_product_fm: changedIntegration[i].int_product_fm,
                        int_product_to: changedIntegration[i].int_product_to,
                        int_class_fm: changedIntegration[i].int_class_fm,
                        int_class_to: changedIntegration[i].int_class_to,
                        int_sub_class_fm: changedIntegration[i].int_sub_class_fm,
                        int_sub_class_to: changedIntegration[i].int_sub_class_to,
                        int_cover_fm: changedIntegration[i].int_cover_fm,
                        int_cover_to: changedIntegration[i].int_cover_to,
                        int_aent_fm: changedIntegration[i].int_aent_fm,
                        int_aent_to: changedIntegration[i].int_aent_to,
                        int_charge_fm: changedIntegration[i].int_charge_fm,
                        int_charge_to: changedIntegration[i].int_charge_to,
                    }
                );
            }



            setNotifyDialogTitle("Note!");
            setNotifyDialogText(`Changes Saved!`);
            setIsNotifyDialogOpen(true);
        } catch (error) {
            console.log(error);
        } finally {
            setIsProcessing(false);
        }
    };

    useEffect(() => {
        fetchIntegrationTypes();
        fetchBizUnits();
        fetchProducts();
        fetchAllSubClasses();
        fetchAllCovers();
        fetchEntityCategories();
        fetchCharges();
        fetchLedgerTypes();
    }, []);

    return (
        <div className='gl-integration'>
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <motion.div
                    className="gl-integration-main-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="gl-integration-center-wrapper">
                        <div className="center-navbar">
                            <div className="navbar-left">
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "1px" }}>
                                    <h1 className="main-title">{selectedIntegrationType?.name}</h1>
                                    <h1 className="sub-title soft" style={{ fontSize: "12px" }}>{selectedIntegrationType?.code}</h1>
                                </div>
                            </div>
                            <div className="navbar-right">
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#00D37F"
                                    tooltip="Save changes"
                                    endIcon={<FaSave />}
                                    onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        borderRadiusType="both"
                                        variant="tint"
                                        color="#0ea5a4"
                                        tooltip={"Add intergration parameters"}
                                        endIcon={<IoAdd />}
                                        onClick={() => {
                                            try {

                                                setSelectedBizUnitFm(null);
                                                setSelectedBizUnitTo(null);
                                                setSelectedProductFm(null);
                                                setSelectedProductTo(null);
                                                setSelectedClassFm(null);
                                                setSelectedClassTo(null);
                                                setSelectedSubClassFm(null);
                                                setSelectedSubClassTo(null);
                                                setSelectedCoverFm(null);
                                                setSelectedCoverTo(null);
                                                setSelectedAentFm(null);
                                                setSelectedAentTo(null);
                                                setSelectedChargeFm(null);
                                                setSelectedChargeTo(null);
                                                setIntLedgers([]);
                                                setObjectToAction({
                                                    object_id: "",
                                                    action_text: "",
                                                    new_doc_status: "newIntegration",
                                                });
                                                setIsLedgerDialogOpen(true);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        {t('add')}
                                    </CustomLoadingButton>}

                            </div>
                        </div>
                        <div className="center-content">
                            <div className="content-navbar">
                                <div className="content-navbar-left">
                                    <div className="search-input-wrapper" style={{ width: "100%" }}>
                                        <FiSearch className="search-input-icon" />
                                        <input
                                            className="search-input"
                                            type="text"
                                            placeholder="Search ledger..."
                                            value={searchTermIntegration}
                                            onChange={(e) => setSearchTermIntegration(e.target.value)}
                                        />
                                        {searchTermIntegration?.length > 0 && (
                                            <IoCloseSharp
                                                onClick={() => setSearchTermIntegration("")}
                                                className="search-input-icon"
                                            />
                                        )}
                                        {searchTermIntegration?.length === 0 && (
                                            <span className="search-input-icon" />
                                        )}
                                    </div></div>
                                <div className="content-navbar-right">
                                    {integrations?.length > integrationRowsPerPage &&
                                        <TablePagination
                                            rowsPerPageOptions={[4]}
                                            rowsPerPage={integrationRowsPerPage}
                                            onRowsPerPageChange={handleIntegrationChangeRowsPerPage}
                                            component="div"
                                            count={integrations?.length}
                                            page={integrationPage}
                                            onPageChange={handleIntegrationChangePage}
                                        />}
                                </div>
                            </div>
                            <div className="table-content">
                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                    <Table sx={{ width: "max-content", border: 'none' }}>
                                        <TableHead className="tablehead">
                                            <TableRow className="tablerow">
                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                    #
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                    <span>{t('details').toUpperCase()}</span>
                                                </TableCell>
                                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                    <span>{t('action').toUpperCase()}</span>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className="tablebody">
                                            {slicedIntegrationData
                                                ?.filter(
                                                    (row) =>
                                                        row?.int_product_fm?.toLowerCase().includes(searchTermIntegration?.toLowerCase()) ||
                                                        row?.int_product_to?.toLowerCase().includes(searchTermIntegration?.toLowerCase())
                                                )
                                                .map((row, index) => (
                                                    <TableRow
                                                        key={row?._id}
                                                        className={`${selectedIntegration?._id === row._id ? "tablerow current" : "tablerow"}`}
                                                        onClick={() => {
                                                            try {
                                                                setSelectedIntegration(row);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                    >
                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                            <h1 className="normal-title">{integrationPage * integrationRowsPerPage + index + 1}</h1>
                                                        </TableCell>
                                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                            <div className="values-row">
                                                                <div className="values-row-left"><h1 className="sub-title">{t('bizUnit')}</h1></div>
                                                                <div className="values-row-right">
                                                                    <span className="sub-title">{`[From : ${bizUnits.find((option) => option.value === row?.int_biz_unit_fm)?.label} - ${row?.int_biz_unit_fm}] : [To: ${bizUnits.find((option) => option.value === row?.int_biz_unit_to)?.label} ${row?.int_biz_unit_to}]`}</span>
                                                                </div>
                                                            </div>
                                                            <div className="values-row">
                                                                <div className="values-row-left"><h1 className="sub-title">{t('product')}</h1></div>
                                                                <div className="values-row-right">
                                                                    <span className="sub-title">{`[From : ${products.find((option) => option.value === row?.int_product_fm)?.label} - ${row?.int_product_fm}] : [To: ${products.find((option) => option.value === row?.int_product_to)?.label} ${row?.int_product_to}]`}</span>
                                                                </div>
                                                            </div>
                                                            {["uw premium booked"].includes(selectedIntegrationType?.code) &&
                                                                <div className="values-row">
                                                                    <div className="values-row-left"><h1 className="sub-title">{t('subClass')}</h1></div>
                                                                    <div className="values-row-right">
                                                                        <span className="sub-title">{`[From : ${allSubClasses.find((option) => option.sc_code === row?.int_sub_class_fm)?.label} - ${row?.int_sub_class_fm}] : [To: ${allSubClasses.find((option) => option.sc_code === row?.int_sub_class_to)?.label} ${row?.int_sub_class_to}]`}</span>
                                                                    </div>
                                                                </div>}
                                                            {["uw premium booked"].includes(selectedIntegrationType?.code) &&
                                                                <div className="values-row">
                                                                    <div className="values-row-left"><h1 className="sub-title">{t('cover')}</h1></div>
                                                                    <div className="values-row-right">
                                                                        <span className="sub-title">{`[From : ${allCovers.find((option) => option.cc_code === row?.int_cover_fm)?.label} - ${row?.int_cover_fm}] : [To: ${allCovers.find((option) => option.cc_code === row?.int_cover_to)?.label} ${row?.int_cover_to}]`}</span>
                                                                    </div>
                                                                </div>}
                                                            {["uw premium booked"].includes(selectedIntegrationType?.code) &&
                                                                <div className="values-row">
                                                                    <div className="values-row-left"><h1 className="sub-title">{t('category')}</h1></div>
                                                                    <div className="values-row-right">
                                                                        <span className="sub-title">{`[From : ${entityCategories.find((option) => option.value === row?.int_aent_fm)?.label} - ${row?.int_aent_fm}] : [To: ${entityCategories.find((option) => option.value === row?.int_aent_to)?.label} ${row?.int_aent_to}]`}</span>
                                                                    </div>
                                                                </div>}
                                                            {["uw charges", "uw comm payable"].includes(selectedIntegrationType?.code) &&
                                                                <div className="values-row">
                                                                    <div className="values-row-left"><h1 className="sub-title">{t('charge')}</h1></div>
                                                                    <div className="values-row-right">
                                                                        <span className="sub-title">{`[From : ${charges.find((option) => option.value === row?.int_charge_fm)?.label} - ${row?.int_charge_fm}] : [To: ${charges.find((option) => option.value === row?.int_charge_to)?.label} ${row?.int_charge_to}]`}</span>
                                                                    </div>
                                                                </div>}
                                                            {/* LEDGERS */}
                                                            <div style={{ display: "flex", flexDirection: "column", margin: "5px 0px", width: "100%", gap: "5px" }}>
                                                                {row.int_ledgers.map((ledger) => (
                                                                    <Chip key={ledger._id} label={`${ledger.ledger_type} - [${ledger.main_ledger_code} : ${ledger.main_ledger_code_xx || ""}] Sub [${ledger.sub_ledger_code} : ${ledger.sub_ledger_code_xx || ""}]`} className="single-cover" />
                                                                ))}
                                                            </div>
                                                        </TableCell>
                                                        <TableCell className="table-cell center" style={{ maxWidth: "100px", gap: "10px" }}>
                                                            <CircularButton
                                                                currentTheme={currentTheme}
                                                                onClick={(e) => {
                                                                    try {
                                                                        setSelectedIntegration(row);

                                                                        setSelectedBizUnitFm({
                                                                            value: row?.int_biz_unit_fm,
                                                                            label: bizUnits.find((option) => option.value === row?.int_biz_unit_fm)?.label
                                                                        });
                                                                        setSelectedBizUnitTo({
                                                                            value: row?.int_biz_unit_to,
                                                                            label: bizUnits.find((option) => option.value === row?.int_biz_unit_to)?.label
                                                                        });

                                                                        setSelectedProductFm({
                                                                            value: row?.int_product_fm,
                                                                            label: products.find((option) => option.value === row?.int_product_fm)?.label
                                                                        });
                                                                        setSelectedProductTo({
                                                                            value: row?.int_product_to,
                                                                            label: products.find((option) => option.value === row?.int_product_to)?.label
                                                                        });

                                                                        const scFm = allSubClasses.find((option) => option.sc_code === row?.int_sub_class_fm);
                                                                        console.log(`scFm ${JSON.stringify(scFm, null, 2)}`);
                                                                        setSelectedSubClassFm({
                                                                            pr_code: scFm?.pr_code,
                                                                            mc_code: scFm?.mc_code,
                                                                            sc_code: scFm?.sc_code,
                                                                            value: scFm?.value,
                                                                            label: scFm?.label,
                                                                        });
                                                                        const scTo = allSubClasses.find((option) => option.sc_code === row?.int_sub_class_to);
                                                                        console.log(`scTo ${JSON.stringify(scTo, null, 2)}`);
                                                                        setSelectedSubClassTo({
                                                                            pr_code: scTo?.pr_code,
                                                                            mc_code: scTo?.mc_code,
                                                                            sc_code: scTo?.sc_code,
                                                                            value: scTo?.value,
                                                                            label: scTo?.label,
                                                                        });

                                                                        const coverFm = allCovers.find((option) => option.cc_code === row?.int_cover_fm);
                                                                        console.log(`coverFm ${JSON.stringify(coverFm, null, 2)}`);
                                                                        setSelectedCoverFm({
                                                                            mc_code: coverFm?.mc_code,
                                                                            sc_code: coverFm?.sc_code,
                                                                            cc_code: coverFm?.cc_code,
                                                                            value: coverFm?.value,
                                                                            label: coverFm?.label,
                                                                        });
                                                                        const coverTo = allCovers.find((option) => option.cc_code === row?.int_cover_to);
                                                                        console.log(`coverTo ${JSON.stringify(coverTo, null, 2)}`);
                                                                        setSelectedCoverTo({
                                                                            mc_code: coverTo?.mc_code,
                                                                            sc_code: coverTo?.sc_code,
                                                                            cc_code: coverTo?.cc_code,
                                                                            value: coverTo?.value,
                                                                            label: coverTo?.label,
                                                                        });

                                                                        // mc_code: cc?.cc_mc_code,
                                                                        // sc_code: cc?.cc_sc_code,
                                                                        // cc_code: cc?.cc_code,
                                                                        // value: `${cc?.cc_mc_code}-${cc?.cc_sc_code}-${cc?.cc_code}`,
                                                                        // label: cc?.cc_name,

                                                                        setSelectedAentFm({
                                                                            value: row?.int_aent_fm,
                                                                            label: entityCategories.find((option) => option.value === row?.int_aent_fm)?.label
                                                                        });
                                                                        setSelectedAentTo({
                                                                            value: row?.int_aent_to,
                                                                            label: entityCategories.find((option) => option.value === row?.int_aent_to)?.label
                                                                        });

                                                                        setSelectedChargeFm({
                                                                            value: row?.int_charge_fm,
                                                                            label: row?.int_charge_fm
                                                                            // label: charges.find((option) => option.value === row?.int_charge_fm)?.label
                                                                        });

                                                                        setSelectedChargeTo({
                                                                            value: row?.int_charge_to,
                                                                            label: row?.int_charge_to,
                                                                            // label: charges.find((option) => option.value === row?.int_charge_to)?.label
                                                                        });

                                                                        setObjectToAction({
                                                                            object_id: "",
                                                                            action_text: "",
                                                                            new_doc_status: "editIntegration",
                                                                        });


                                                                        setIntLedgers([]);
                                                                        setIntLedgers(row?.int_ledgers);

                                                                        setIsLedgerDialogOpen(true);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }} icon={<MdEdit color="green" />} width={"35px"} height={"35px"} />

                                                            <CircularButton
                                                                currentTheme={currentTheme}
                                                                onClick={(e) => {
                                                                    try {
                                                                        e.stopPropagation();
                                                                        setSelectedIntegration(row);
                                                                        setConfirmationActiontext(`Do you want to selected intergration?`);
                                                                        setConfirmDialogAction("deleteIntegration");
                                                                        setIsConfirmDialogOpen(true);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }} color="#E53935" icon={<MdDelete/>} width={"35px"} height={"35px"} />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </div>
                    <div className="gl-integration-right-wrapper">
                        <div className="search-input-wrapper" style={{ width: "95%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                                className="search-input"
                                type="text"
                                placeholder={t('search')}
                                value={searchTermTypes}
                                onChange={(e) => setSearchTermTypes(e.target.value)}
                            />
                            {searchTermTypes?.length > 0 && (
                                <IoClose
                                    onClick={async () => setSearchTermTypes("")}
                                    className="search-input-icon"
                                />
                            )}
                        </div>
                        <div className="options-list">
                            {integrationTypes
                                ?.filter(
                                    (row) =>
                                        row?.code?.toLowerCase().includes(searchTermTypes?.toLowerCase()) ||
                                        row?.name?.toLowerCase().includes(searchTermTypes?.toLowerCase())
                                )
                                .map((row) => (
                                    <span
                                        key={row._id}
                                        className={`${selectedIntegrationType?._id === row._id
                                            ? "single-option active"
                                            : "single-option"
                                            }`}
                                        onClick={async () => {
                                            try {
                                                await fetchIntegration(row.code);
                                                setSelectedIntegrationType(row);
                                                setIntegrationPage(0);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        <h1 className="sub-title">{row?.name}</h1>
                                        <h1 className="sub-title soft">{row?.code}</h1>
                                    </span>
                                ))}
                        </div>
                    </div>
                </motion.div>
            )}
            {isLedgerDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">
                                {objectToAction?.new_doc_status === "newIntegration"
                                    ? "Add Integration"
                                    : objectToAction?.new_doc_status === "editIntegration"
                                        ? "Edit Integration" : "Action"}
                            </h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        setIsLedgerDialogOpen(false);
                                    } catch (error) {
                                        console.log(error)
                                    }
                                }} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <div className="input-item-with-label" style={{ gap: "10px" }}>
                                <label
                                    htmlFor="int_biz_unit_fm"
                                    style={{
                                        width: "100px",
                                    }}
                                >
                                    {t('bizUnit').toUpperCase()}
                                </label>
                                <Select
                                    id="int_biz_unit_fm"
                                    name="int_biz_unit_fm"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    width="200px"
                                    value={selectedBizUnitFm}
                                    onChange={(selectedOption) => {
                                        try {
                                            setSelectedBizUnitFm(selectedOption);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                    options={bizUnits}
                                    isSearchable={true}
                                    placeholder={t('from')}
                                />
                                <Select
                                    id="int_biz_unit_to"
                                    name="int_biz_unit_to"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    width="200px"
                                    value={selectedBizUnitTo}
                                    onChange={(selectedOption) => {
                                        try {
                                            setSelectedBizUnitTo(selectedOption);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                    options={bizUnits}
                                    isSearchable={true}
                                    placeholder={t('to')}
                                />
                            </div>
                            <div className="input-item-with-label" style={{ gap: "10px" }}>
                                <label
                                    htmlFor="int_product_fm"
                                    style={{
                                        width: "100px",
                                    }}
                                >
                                    {t('product')}
                                </label>
                                <Select
                                    id="int_product_fm"
                                    name="int_product_fm"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    width="200px"
                                    value={selectedProductFm}
                                    onChange={(selectedOption) => {
                                        try {
                                            setSelectedProductFm(selectedOption);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                    options={products}
                                    isSearchable={true}
                                    placeholder={t('from')}
                                />
                                <Select
                                    id="int_product_to"
                                    name="int_product_to"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    width="200px"
                                    value={selectedProductTo}
                                    onChange={(selectedOption) => {
                                        try {
                                            setSelectedProductTo(selectedOption);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                    options={products}
                                    isSearchable={true}
                                    placeholder={t('to')}
                                />
                            </div>
                            {["uw premium booked"].includes(selectedIntegrationType?.code) &&
                                <div className="input-item-with-label" style={{ gap: "10px" }}>
                                    <label
                                        htmlFor="int_sub_class_fm"
                                        style={{
                                            width: "100px",
                                        }}
                                    >
                                        {t('subClasses').toUpperCase()}
                                    </label>
                                    <Select
                                        id="int_sub_class_fm"
                                        name="int_sub_class_fm"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        width="200px"
                                        value={allSubClasses.find((option) => option.sc_code === selectedSubClassFm?.sc_code) || null}
                                        onFocus={() => handleSubClassFocus(selectedProductFm?.value, selectedProductTo?.value)}
                                        onChange={(selectedOption) => {
                                            try {
                                                console.log(`setSelectedSubClassFm  ${JSON.stringify(selectedOption, null, 2)}`);
                                                setSelectedClassFm(selectedOption?.mc_code);
                                                setSelectedSubClassFm(selectedOption);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        options={subClasses}
                                        isSearchable={true}
                                        placeholder={t('from')}
                                    />
                                    <Select
                                        id="int_sub_class_to"
                                        name="int_sub_class_to"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        width="200px"
                                        value={allSubClasses.find((option) => option.sc_code === selectedSubClassTo?.sc_code) || null}
                                        onFocus={() => handleSubClassFocus(selectedProductFm?.value, selectedProductTo?.value)}
                                        onChange={(selectedOption) => {
                                            try {
                                                setSelectedClassTo(selectedOption?.mc_code);
                                                setSelectedSubClassTo(selectedOption);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        options={subClasses}
                                        isSearchable={true}
                                        placeholder={t('to')}
                                    />
                                </div>}
                            {["uw premium booked"].includes(selectedIntegrationType?.code) &&
                                <div className="input-item-with-label" style={{ gap: "10px" }}>
                                    <label
                                        htmlFor="int_cover_fm"
                                        style={{
                                            width: "100px",
                                        }}
                                    >
                                        {t('covers').toUpperCase()}
                                    </label>
                                    <Select
                                        id="int_cover_fm"
                                        name="int_cover_fm"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        width="200px"
                                        value={allCovers.find((option) => option.cc_code === selectedCoverFm?.cc_code) || null}
                                        onFocus={() => handleCoverFocus(selectedSubClassFm?.sc_code, selectedSubClassTo?.sc_code)}
                                        onChange={(selectedOption) => {
                                            try {
                                                setSelectedCoverFm(selectedOption);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        options={covers}
                                        isSearchable={true}
                                        placeholder={t('from')}
                                    />
                                    <Select
                                        id="int_cover_to"
                                        name="int_cover_to"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        width="200px"
                                        value={allCovers.find((option) => option.cc_code === selectedCoverTo?.cc_code) || null}
                                        onFocus={() => handleCoverFocus(selectedSubClassFm?.sc_code, selectedSubClassTo?.sc_code)}
                                        onChange={(selectedOption) => {
                                            try {
                                                console.log(`setSelectedCoverFm  ${JSON.stringify(selectedOption, null, 2)}`);
                                                setSelectedCoverTo(selectedOption);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        options={covers}
                                        isSearchable={true}
                                        placeholder={t('to')}
                                    />
                                </div>}
                            {["uw charges", "uw comm payable"].includes(selectedIntegrationType?.code) &&
                                <div className="input-item-with-label" style={{ gap: "10px" }}>
                                    <label
                                        htmlFor="int_charge_fm"
                                        style={{
                                            width: "100px",
                                        }}
                                    >
                                        {t('charge').toUpperCase()}
                                    </label>
                                    <Select
                                        id="int_charge_fm"
                                        name="int_charge_fm"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        width="200px"
                                        value={selectedChargeFm}
                                        onChange={(selectedOption) => {
                                            try {
                                                setSelectedChargeFm(selectedOption);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        options={charges}
                                        isSearchable={true}
                                        placeholder={t('from')}
                                    />
                                    <Select
                                        id="int_charge_to"
                                        name="int_charge_to"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        width="200px"
                                        value={selectedChargeTo}
                                        onChange={(selectedOption) => {
                                            try {
                                                setSelectedChargeTo(selectedOption);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        options={charges}
                                        isSearchable={true}
                                        placeholder={t('to')}
                                    />
                                </div>}
                            {["uw premium booked"].includes(selectedIntegrationType?.code) &&
                                <div className="input-item-with-label" style={{ gap: "10px" }}>
                                    <label
                                        htmlFor="int_aent_fm"
                                        style={{
                                            width: "100px",
                                        }}
                                    >
                                        {t('category').toUpperCase()}
                                    </label>
                                    <Select
                                        id="int_aent_fm"
                                        name="int_aent_fm"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        width="200px"
                                        value={selectedAentFm}
                                        onChange={(selectedOption) => {
                                            try {
                                                setSelectedAentFm(selectedOption);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        options={entityCategories}
                                        isSearchable={true}
                                        placeholder="From"
                                    />
                                    <Select
                                        id="int_aent_to"
                                        name="int_aent_to"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        width="200px"
                                        value={selectedAentTo}
                                        onChange={(selectedOption) => {
                                            try {
                                                setSelectedAentTo(selectedOption);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        options={entityCategories}
                                        isSearchable={true}
                                        placeholder="To"
                                    />
                                </div>}
                            <hr className="separator-h" />
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="int_aent_fm"
                                    style={{
                                        width: "110px",
                                    }}
                                >
                                    {t('main').toUpperCase()}
                                </label>
                                <AsyncSelect
                                    id="mgl_code"
                                    name="mgl_code"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    width="410px"
                                    value={selectedMgl}
                                    onChange={(selectedOption) => setSelectedMgl(selectedOption)}
                                    loadOptions={(inputValue, callback) => fetchMainLedgers(inputValue, callback, [])}
                                    isSearchable={true}
                                    placeholder={t('main')}
                                    noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                            </div>
                            <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                <div className="input-item-with-label">
                                    <label
                                        htmlFor="int_aent_fm"
                                        style={{
                                            width: "110px",
                                        }}
                                    >
                                        {t('sub').toUpperCase()}
                                    </label>
                                    <AsyncSelect
                                        id="sgl_code"
                                        name="sgl_code"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999,
                                            })
                                        }}
                                        width="350px"
                                        value={selectedSgl}
                                        onChange={(selectedOption) => setSelectedSgl(selectedOption)}
                                        loadOptions={(inputValue, callback) => fetchSubLedgers(inputValue, callback, selectedMgl?.value)}
                                        isSearchable={true}
                                        placeholder={t('sub')}
                                        noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
                                </div>
                                <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={async () => {
                                        try {
                                            // if (!selectedLedgerType?.value) {
                                            //     setNotifyDialogTitle("Note!");
                                            //     setNotifyDialogText(`Select type!`);
                                            //     setIsNotifyDialogOpen(true);
                                            //     return;
                                            // }

                                            if (!selectedMgl?.value) {
                                                setNotifyDialogTitle("Note!");
                                                setNotifyDialogText(`Select ledger!`);
                                                setIsNotifyDialogOpen(true);
                                                return;
                                            }

                                            const ledgers = intLedgers.find((option) => option?.ledger_type === "primary");

                                            const updatedDoc = {
                                                ledger_type: "primary",
                                                main_ledger_code: selectedMgl?.value,
                                                sub_ledger_code: selectedSgl?.value || "",
                                                main_ledger_code_xx: selectedMgl?.label || "",
                                                sub_ledger_code_xx: selectedSgl?.label || "",
                                            };

                                            setSelectedMgl(null);
                                            setSelectedLedgerType(null);
                                            if (ledgers) {
                                                setIntLedgers((prev) => {
                                                    return prev.map((param) =>
                                                        param.ledger_type === updatedDoc.ledger_type ? updatedDoc : param
                                                    );
                                                });
                                                showToast("Updated!", "success");
                                            } else {
                                                setIntLedgers((prev) => [...prev, updatedDoc]);
                                                showToast("Added!", "success");
                                            }
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }} icon={<MdAdd />} width={"35px"} height={"35px"} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", margin: "5px 0px", width: "100%", gap: "5px" }}>
                                {intLedgers?.map((ledger, index) => (
                                    <Chip key={index} label={`${ledger?.ledger_type} - [${ledger?.main_ledger_code} : ${ledger?.main_ledger_code_xx}] Sub [${ledger?.sub_ledger_code} : ${ledger?.sub_ledger_code_xx}]`} className="single-cover" onDelete={() => { }} />
                                ))}
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                endIcon={objectToAction?.new_doc_status === "newIntegration" ? <IoAdd /> : <IoCheckmarkDone />}
                                onClick={handleAddIntegration}
                            >
                                {objectToAction?.new_doc_status === "newIntegration"
                                    ? "Add Integration"
                                    : objectToAction?.new_doc_status === "editIntegration"
                                        ? "Update Integration" : "Action"}
                            </CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle="Confirmation"
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
        </div>
    )
}



export default GlIntegration;